module.exports = __webpack_public_path__ + "img/4_x12.3d262459.png";